export { default } from "./ShopItemAd";
